<template>
  <div :style="`${fullHeight}, min-width: ${width}px;`">
    <v-select
      v-if="show"
      :items="items"
      item-title="name"
      item-value="id"
      style="border-radius: 0; font-size: 14px"
      :label="label"
      v-model="soilTypeValue"
      item-disabled="disabled"
      hide-details
      :density="density"
      variant="plain"
      :class="[dirtyClass, density]"
    >
      <template v-slot:item="{ item, props }">
        <v-list-item v-bind="props" class="header-text-container">
          <template #prepend>
            <ColorIndicator :size="18" :color="item.raw.color" />
          </template>
          <template #title>
            <span class="header-text">{{ item.raw.name }}</span>
          </template>
        </v-list-item>
      </template>
      <template v-slot:selection="{ item }">
        <div class="pl-2" style="display: flex; align-items: center">
          <ColorIndicator :size="18" :color="item.raw.color" />
          <span class="header-text">{{ item.raw.name }}</span>
        </div>
      </template>
    </v-select>
    <div v-else class="mt-0 mr-2">
      <span>
        {{ soilTypeValue ? soilTypeValue.name : null }}
      </span>
    </div>
  </div>
</template>
<script>
import ColorIndicator from '@/components/common/ColorIndicator.vue'

export default {
  name: 'DropDownSoilType',
  props: {
    items: { required: true },
    width: { default: '100%', required: false },
    item: { required: true },
    show: { default: true, required: false },
    dirtyClass: { required: false },
    label: { default: '', required: false },
    basic: { default: false, required: false }
  },
  computed: {
    soilTypeValue: {
      get() {
        return this.getSoilType(this.item)
      },
      set(value) {
        this.$emit('set', value)
        this.$emit('addDirty')
      }
    },
    emptyField() {
      return this.item[this.parameter] ? 'border-bottom-red' : ''
    },
    fullHeight() {
      const heightVal = 'height: 100%;'
      return !this.basic ? heightVal : ''
    },
    density() {
      return this.basic ? 'compact' : 'default'
    }
  },
  methods: {
    getSoilType(soilTypeId) {
      return this.items.find((item) => soilTypeId === item.id)
    }
  },
  components: { ColorIndicator }
}
</script>
<style scoped>
.custom input[type='number'] {
  -moz-appearance: textfield;
}

.custom.v-autocomplete.v-autocomplete--enclosed .v-input__slot {
  padding-left: 8px !important;
}

.header-text-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.header-text {
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 12px;
  margin-right: 4px;
  text-align: center;
}

.compact :deep(.v-field__input) {
  padding-top: 0 !important;
}

.compact :deep(.v-field__append-inner) {
  padding-top: 0 !important;
  align-items: center !important;
}
</style>
